/* “The range that pays for itself” — clean card style: separate white cards
   with rounded corners and a soft shadow, a square photo panel on brand
   mist, the badge as a pill over the photo, then name, spec line, price and
   a full-width buy button. Three equal columns.

   The 2IN1 Solar/Electric Light has been withdrawn, but it is baked into
   the ported homepage markup, so its card is removed here.

   Note: the stylesheet is injected once and keyed by version. Removing and
   re-adding it on every pass would retrigger the MutationObserver and lock
   up the renderer.

   Previous four-column hairline layout is kept at
   assets/bsl-range-v1-backup.js.liquid if this needs reverting. */
(function () {
  var V = "3";
  var STYLE_ID = "bsl-range-style-v" + V;
  var GOLD = "#F5A800";
  var INK = "#171A15";
  var MIST = "#EEF0EB";
  var MUTED = "#6E7268";

  var WITHDRAWN = /2\s*in\s*1|2in1/i;

  var ORDER = [
    { m: /2500W Ultra/i, o: 1 },
    { m: /3000W/i, o: 2 },
    { m: /800W/i, o: 3 },
    { m: /300W/i, o: 4 },
    { m: /Commercial/i, o: 5 }
  ];

  function styles() {
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement("style");
    s.id = STYLE_ID;
    s.textContent = [
      "#range .bsl-grid{display:grid !important;" +
        "grid-template-columns:repeat(3,minmax(0,1fr)) !important;" +
        "grid-auto-rows:1fr !important;gap:1.5rem !important;" +
        "background:transparent !important;border:0 !important;" +
        "padding:0 !important;margin-top:2.5rem !important}",
      "#range .bsl-grid > *{grid-column:span 1 !important;grid-row:span 1 !important}",
      "#range .bsl-gone{display:none !important}",

      "#range .bsl-card{position:relative !important;display:flex !important;" +
        "flex-direction:column !important;background:#fff !important;" +
        "border:1px solid rgba(23,26,21,.07) !important;border-radius:24px !important;" +
        "box-shadow:0 8px 40px rgba(23,26,21,.06) !important;" +
        "overflow:hidden !important;padding:0 !important;height:100% !important;" +
        "transition:transform .35s ease, box-shadow .35s ease}",
      "#range .bsl-card:hover{transform:translateY(-4px) !important;" +
        "box-shadow:0 18px 54px rgba(23,26,21,.10) !important}",

      "#range .bsl-well{order:1 !important;width:100% !important;" +
        "aspect-ratio:1/1 !important;height:auto !important;min-height:0 !important;" +
        "background:" + MIST + " !important;padding:1.75rem !important;" +
        "margin:0 !important;display:flex !important;align-items:center !important;" +
        "justify-content:center !important;overflow:hidden !important;flex:0 0 auto !important}",
      "#range .bsl-well img{max-height:100% !important;max-width:100% !important;" +
        "width:auto !important;height:auto !important;object-fit:contain !important;" +
        "transition:transform .6s ease}",
      "#range .bsl-card:hover .bsl-well img{transform:scale(1.04) !important}",

      "#range .bsl-badgerow{position:absolute !important;top:14px !important;" +
        "left:14px !important;z-index:3 !important;width:auto !important;" +
        "margin:0 !important;padding:0 !important;display:block !important}",
      "#range .bsl-badgerow > p,#range .bsl-badgerow > div:not(:first-child){display:none !important}",
      "#range .bsl-badgerow > span{display:inline-block !important;background:" + GOLD + " !important;" +
        "color:" + INK + " !important;border-radius:999px !important;" +
        "padding:.4rem .8rem !important;font-size:.66rem !important;font-weight:800 !important;" +
        "letter-spacing:.12em !important;text-transform:uppercase !important;" +
        "box-shadow:0 4px 14px rgba(23,26,21,.16) !important;white-space:nowrap !important}",
      "#range .bsl-nobadge{display:none !important}",

      "#range .bsl-card h3{order:2 !important;padding:1.35rem 1.35rem 0 !important;" +
        "margin:0 !important;font-size:1.08rem !important;font-weight:700 !important;" +
        "line-height:1.35 !important;letter-spacing:-.01em !important;color:" + INK + " !important}",
      "#range .bsl-sub{order:3 !important;padding:.45rem 1.35rem 0 !important;" +
        "margin:0 !important;flex:1 1 auto !important;font-size:.82rem !important;" +
        "line-height:1.5 !important;color:" + MUTED + " !important;letter-spacing:0 !important;" +
        "text-transform:none !important;font-family:Inter,system-ui,sans-serif !important}",
      "#range .bsl-buy{order:4 !important;display:flex !important;flex-wrap:wrap !important;" +
        "align-items:flex-end !important;gap:.5rem !important;" +
        "padding:1rem 1.35rem 1.35rem !important;margin:0 !important;flex:0 0 auto !important}",
      "#range .bsl-buy > *:first-child{font-size:1.45rem !important;" +
        "font-weight:800 !important;color:" + INK + " !important;line-height:1 !important}",
      "#range .bsl-buy s,#range .bsl-buy del,#range .bsl-buy .line-through{font-size:.85rem !important;" +
        "color:" + MUTED + " !important;font-weight:400 !important}",
      "#range .bsl-buy a,#range .bsl-buy button{order:9 !important;width:100% !important;" +
        "margin-top:.85rem !important;display:flex !important;align-items:center !important;" +
        "justify-content:center !important;background:" + GOLD + " !important;" +
        "color:" + INK + " !important;border:0 !important;border-radius:999px !important;" +
        "padding:.8rem 1rem !important;font-size:.8rem !important;font-weight:800 !important;" +
        "letter-spacing:.1em !important;text-transform:uppercase !important;" +
        "text-decoration:none !important;white-space:nowrap !important;cursor:pointer !important;" +
        "transition:background .2s ease}",
      "#range .bsl-buy a:hover,#range .bsl-buy button:hover{background:#FFC94D !important}",
      "#range .bsl-buy a::after,#range .bsl-buy a::before{display:none !important}",

      "#range h3,#range p,#range span,#range a{overflow-wrap:normal !important;" +
        "word-break:normal !important}",
      "#range .bsl-spec-row{display:none !important}",

      "@media(max-width:1024px){#range .bsl-grid{grid-template-columns:repeat(2,minmax(0,1fr)) !important}}",
      "@media(max-width:640px){#range .bsl-grid{grid-template-columns:1fr !important;" +
        "grid-auto-rows:auto !important;gap:1.25rem !important}}",

      "main section,main > div > section{padding-top:3rem !important;padding-bottom:3rem !important}",
      "@media(min-width:640px){main section,main > div > section{padding-top:3.75rem !important;padding-bottom:3.75rem !important}}",
      ".bsl-stats-band{padding-top:2.25rem !important;padding-bottom:2.25rem !important}",
      ".bsl-stats-band .mx-auto{padding-top:0 !important;padding-bottom:0 !important}",
      "@media(min-width:640px){.bsl-stats-band{padding-top:2.75rem !important;padding-bottom:2.75rem !important}}",
      "#homes{padding-bottom:2.5rem !important}",
      "#business,#projects{padding-top:2.5rem !important}",
      "@media(min-width:640px){#homes{padding-bottom:3rem !important}#business,#projects{padding-top:3rem !important}}",
      "#range{padding-top:3rem !important;padding-bottom:3.5rem !important}"
    ].join("");
    document.head.appendChild(s);
  }

  function stripSpecChips(card) {
    var imgs = card.querySelectorAll(
      'img[src*="icon-shield"],img[src*="icon-battery"],img[src*="icon-sun-panel"],' +
      'img[src*="icon-moon"],img[src*="icon-radar"],img[src*="icon-wrench"],' +
      'img[src*="icon-truck"],img[src*="icon-coin"]'
    );
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      var row = img.parentElement;
      for (var up = 0; up < 3 && row && row !== card; up++) {
        if (row.parentElement === card || (row.children.length > 1 && row.textContent.trim())) break;
        row = row.parentElement;
      }
      var target = row && row !== card ? row : img.parentElement;
      if (target && target !== card) target.remove();
      else img.remove();
    }
  }

  function rangeGrid() {
    var r = document.getElementById("range");
    if (!r) return;

    var grid = null, divs = r.querySelectorAll("div");
    for (var i = 0; i < divs.length; i++) {
      if (getComputedStyle(divs[i]).display === "grid" && divs[i].children.length >= 5) {
        grid = divs[i];
        break;
      }
    }
    if (!grid) return;
    if (!grid.classList.contains("bsl-grid")) grid.classList.add("bsl-grid");

    var cap = grid.querySelector(".bsl-endcap");
    if (cap) cap.remove();

    Array.prototype.slice.call(grid.children).forEach(function (c) {
      var h3 = c.querySelector("h3");
      var title = h3 ? h3.textContent : "";

      /* withdrawn line — keep it off the page */
      if (title && WITHDRAWN.test(title)) {
        c.classList.add("bsl-gone");
        return;
      }

      if (c.dataset.bslCard === V) return;
      c.dataset.bslCard = V;
      c.classList.add("bsl-card");

      var kids = c.children;
      if (!kids.length) return;

      /* the first child is the whole-card link injected by bsl-shop.js, so
         the badge row is the first DIV that has no photo in it */
      var head = null;
      for (var hi = 0; hi < kids.length; hi++) {
        if (kids[hi].tagName === "DIV" && !kids[hi].querySelector("img")) { head = kids[hi]; break; }
      }
      if (head) {
        var badge = head.querySelector("span");
        if (badge && badge.textContent.trim()) head.classList.add("bsl-badgerow");
        else head.classList.add("bsl-nobadge");
      }

      for (var j = 0; j < kids.length; j++) {
        if (kids[j].tagName === "DIV" && kids[j].querySelector("img")) {
          kids[j].classList.add("bsl-well");
          break;
        }
      }

      kids[kids.length - 1].classList.add("bsl-buy");
      if (!h3) return;

      var sub = h3.nextElementSibling;
      if (sub && sub !== kids[kids.length - 1]) sub.classList.add("bsl-sub");

      for (var k = 0; k < ORDER.length; k++) {
        if (ORDER[k].m.test(title)) { c.style.order = ORDER[k].o; break; }
      }

      if (/2500W Ultra/i.test(title)) stripSpecChips(c);
    });
  }

  function statsBand() {
    if (document.querySelector(".bsl-stats-band")) return;
    var w = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null), n, node = null;
    while ((n = w.nextNode())) {
      if (/^\s*Safe & secure\s*$/.test(n.nodeValue)) { node = n; break; }
    }
    if (!node) return;
    var sec = node.parentElement && node.parentElement.closest("section");
    if (sec) sec.classList.add("bsl-stats-band");
  }

  function run() { styles(); rangeGrid(); statsBand(); }

  new MutationObserver(run).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState !== "loading") run();
  else document.addEventListener("DOMContentLoaded", run);
  window.addEventListener("load", run);
})();
